import clsx from "clsx";
import Button from "@/components/ui/button";
import { PartComponent, PartName } from "@/types/design";
import usePart from "./Part.hook";
import styles from "./Part.module.scss";
import { selectingPartStore } from "@/store/partsStore";

type Props = {
	partComponent: PartComponent;
	partName: PartName;
};

/**
 * パーツ コンポーネント
 * @returns {JSX.Element} パーツ コンポーネント
 */
export default function Part(props: Props) {
	const { partComponent, partName } = props;
	const { body, onPartClick } = usePart();
	const { selectingPart } = selectingPartStore();

	const { partId: selectingPartId, partName: selectingPartName } =
		selectingPart;

	// TODO: ここでこれやるの明らかにダメそうな気がする→パフォ低下不可避
	const bodyIsSelected =
		body.find((m) => m.partName === partName)?.partId === partComponent.id;
	const isSelected =
		(partName === selectingPartName &&
			partComponent.id === selectingPartId) ||
		bodyIsSelected;

	return (
		<Button
			className={clsx(styles.part, isSelected && styles.isSelected)}
			onClick={() => onPartClick(partComponent.id, partName)}
		>
			{partComponent.part}
		</Button>
	);
}
